import React from "react";
import logo from '../aseets/logo.svg'

const LoadingScreen = ({fadeOut }) => {
  return (
    <div
      className={`fixed inset-0 flex flex-col items-center justify-center bg-white z-50 transition-opacity duration-500 ${
        fadeOut ? "opacity-0" : "opacity-100"
      }`}
    >
      {/* Logo Animation */}
      <div className="mb-6 animate-pulse">
        <img src={logo} alt="Brand Logo" className="w-64 h-40" />
      </div>

      {/* Custom Loader */}
      <div className="relative w-16 h-16">
        <div className="absolute inset-0 border-4 border-gray-300 border-t-[#08875D] rounded-full animate-spin"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-8 h-8 primary-bg rounded-full animate-bounce"></div>
        </div>
      </div>

      {/* Text Animation */}
      <p className="mt-1 text-lg text-gray-600 font-medium animate-fade-in">
        Preparing your experience...
      </p>
    </div>
  );
};

export default LoadingScreen;
